module.exports = __webpack_public_path__ + "media/images/solution_private-b238985243fd613efdc7ae07d33b1739.svg";